import { render, staticRenderFns } from "./VarReportDefinitionCard.vue?vue&type=template&id=629e64f6&scoped=true&"
import script from "./VarReportDefinitionCard.vue?vue&type=script&lang=js&"
export * from "./VarReportDefinitionCard.vue?vue&type=script&lang=js&"
import style0 from "./VarReportDefinitionCard.vue?vue&type=style&index=0&id=629e64f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629e64f6",
  null
  
)

export default component.exports